import { Injectable, Injector } from '@angular/core';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { ICreateChangeBase } from '@fi-shared/models/models';
import { ILightWeightObject } from '@fi-shared/models';

export interface IClusterModel extends ICreateChangeBase {
    Id?: number;
    Name?: string;
    Description?: string;
    IsSystemObject?: boolean;
    Names?: IContentLanguageLabelModel[];
    Descriptions?: IContentLanguageLabelModel[];
    BusinessUnits?: ILightWeightObject[];
}

@Injectable()
export class ClusterModel {
    Id = 0;
    Name = '';
    Description = '';
    Names: IContentLanguageLabelModel[] = [];
    Descriptions: IContentLanguageLabelModel[] = [];
    CreatedByUserId = 0;
    CreatedByUserName = '';
    CreatedOn: string; //ISO 8601 date
    ChangedByUserId = 0;
    ChangedByUserName = '';
    ChangedOn: string; //ISO 8601 date
    BusinessUnits: ILightWeightObject[] = [];
    IsSystemObject = false;

    constructor(cluster: IClusterModel, injector: Injector) {
        this.initialize(cluster || {}, injector);
    }

    private initialize(cluster: IClusterModel, injector: Injector) {
        this.Id = cluster.Id;
        this.Name = cluster.Name;
        this.Description = cluster.Description;
        this.CreatedByUserId = cluster.CreatedByUserId;
        this.CreatedByUserName = cluster.CreatedByUserName;
        this.CreatedOn = cluster.CreatedOn;
        this.ChangedByUserId = cluster.ChangedByUserId;
        this.ChangedByUserName = cluster.ChangedByUserName;
        this.ChangedOn = cluster.ChangedOn;
        this.BusinessUnits = cluster.BusinessUnits;
        this.IsSystemObject = cluster.IsSystemObject || false;

        const contentLanguagesService = injector.get(ContentLanguagesService);
        contentLanguagesService.InitializeContentLanguagesArray(this.Names, cluster.Names, true);
        contentLanguagesService.InitializeContentLanguagesArray(this.Descriptions, cluster.Descriptions, true);
    }
}
